import type { CivicEntry, EducationEntry } from '../types/profile'

export const committeeCraft = [
  {
    committee: 'Audit & Risk Committee',
    role: 'Chair',
    focus:
      'Control environment, external audit relationship, risk appetite and assurance mapping across grant and commercial income.',
  },
  {
    committee: 'Remuneration Committee',
    role: 'Chair',
    focus:
      'Executive reward policy, long-term incentive design and pay alignment through change of control.',
  },
  {
    committee: 'Employee Benefit Trust',
    role: 'Chair',
    focus:
      'Beneficiary interests, trustee duties and employee protection during a change of ownership.',
  },
  {
    committee: 'Nomination & Succession',
    role: 'Board member',
    focus:
      'Board composition, skills mapping, chief executive appointment and orderly succession planning.',
  },
]

export const education: EducationEntry[] = [
  {
    qualification: 'Senior Civil Service leadership programme',
    institution: 'UK Civil Service',
    period: 'Executive development',
  },
  {
    qualification: 'Board and non-executive director development',
    institution: 'Institute of Directors tradition of practice',
    period: 'Continuing',
  },
  {
    qualification: 'Economics and public administration foundation',
    institution: 'United Kingdom',
    period: 'Undergraduate',
  },
]

export const civicRoles: CivicEntry[] = [
  {
    title: 'King’s Ambassador',
    organisation: 'Industrial Cadets',
    detail:
      'Royal-appointed ambassadorial role championing accredited industrial experience, STEM outreach and access into advanced manufacturing careers for young people.',
  },
  {
    title: 'Commissioner Panel Member',
    organisation: 'ACAS',
    detail:
      'Served on the arbitration and conciliation commissioner panel, contributing to the resolution of national workplace disputes.',
  },
  {
    title: 'Advocate for the future workforce',
    organisation: 'Industry & education partnerships',
    detail:
      'Convenes employers, education providers and government around the skills pipeline that industrial strategy depends upon.',
  },
]
